export default function PHP_delete() {
  return (
    <div>
      <h1>PHP_delete</h1>
    </div>
  );
}
